module.exports = __webpack_public_path__ + "static/art3-3155c606fdd883a716d738f17a4106a8.jpg";